import { render } from "./DlAuxDistributionSection.vue?vue&type=template&id=2df85470"
import script from "./DlAuxDistributionSection.vue?vue&type=script&lang=js"
export * from "./DlAuxDistributionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__